module.exports = __webpack_public_path__ + "home_back1.606a96af46833b40474d.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/assets/images/home_back1.jpg
// module id = ../../../../../src/assets/images/home_back1.jpg
// module chunks = 1